module.exports = __webpack_public_path__ + "static/img/hainan-fangxinyou.9616ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hainan-fangxinyou.png
// module id = qpu5
// module chunks = 1 2